'use client';

import Typography from '@components/Typography';
import type { NextPage } from 'next';

type Props = {
  reset: () => void;
  error: Error & { digest?: string };
};

const ErrorPage: NextPage<Props> = ({ error }) => (
  <Typography variant="Heading 2 - 24" data-testid="page-header">
    {error.message}
  </Typography>
);

export default ErrorPage;
